// React
import { ReactElement, FC } from 'react';
// Design System
import { Font } from '@utmb/design-system/text/font';
// Styles
import styles from './user-edit-wrapper.module.scss';

interface UserEditWrapperProps {
    title: string;
    summary?: string;
}

export const UserEditWrapper: FC<UserEditWrapperProps> = (props): ReactElement => {
    const { title, summary, children } = props;

    return (
        <div className={styles.root}>
            {title && (
                <Font.FuturaMedium mobile="22" desktop="32" className={styles.title}>
                    {title}
                </Font.FuturaMedium>
            )}
            {summary && (
                <Font.FuturaBook mobile="16" desktop="16" className={styles.helper_summary}>
                    {summary}
                </Font.FuturaBook>
            )}
            {children}
        </div>
    );
};
